export default "__VITE_ASSET__CIyZygWb__"